import axios from 'axios'
import { toast } from 'react-toastify'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'cfgCommon/endpoints'

export async function getSavingsPlanSubscription(id) {
    const { data } = await axios.get(`${SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT}/${id}`)
    
    //Se determina el tiempo de duración del mensaje
    const toastMessageDuration = 5000
    
    // Se simplifica el array con los datos que necesito
    data.quotes = data.quotes.map(q => ({ quote: q.quote }))
    const options = {
        autoClose: toastMessageDuration
    }
    data.alerts.forEach(alert => {

        toast.warning(alert.message, options)
    });

    return data
}
